import { AfterContentChecked, Directive, ElementRef, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[eguardIfOnDom]'
})
export class EguardIfOnDomatirective implements AfterContentChecked {
    isCreated = false;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private element: ElementRef
    ) {
    }

    ngAfterContentChecked() {
        if (document.body.contains(this.element.nativeElement) && !this.isCreated) {
            setTimeout(() => {
                this.viewContainer.createEmbeddedView(this.templateRef);
            }, 0);
            this.isCreated = true;
        }
        else if (this.isCreated && !document.body.contains(this.element.nativeElement)) {
            this.viewContainer.clear();
            this.isCreated = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/core/directives/eguard-if-on-dom/eguard-if-on-dom.directive.ts